import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { DraggableModalWrapperComponent } from './draggable-modal-wrapper/draggable-modal-wrapper.component';
import { ModalData } from './models/modal-data';

@Component({
    selector: 'app-modal',
    imports: [
        MatDialogModule,
        MatButtonModule,
        ReactiveFormsModule,
        FormsModule,
        DraggableModalWrapperComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './modal.component.html',
})
export class ModalComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ModalData,
        private dialogRef: MatDialogRef<ModalComponent>,
    ) {}

    onCancel(): void {
        this.dialogRef.close(false);
    }

    onPrimaryAction(): void {
        this.data.primaryAction?.action?.();

        this.dialogRef.close(true);
    }

    onSecondaryAction(): void {
        this.data.secondaryAction?.action?.();

        this.dialogRef.close(false);
    }
}
